import React, { useContext, useState, useEffect } from "react";
import { Alert } from "reactstrap";
import { StateContext } from "../../utils/context";
import { useFetch } from "../../utils/fetchHook";
import { getCookie } from "../../jwt/_helpers/cookie";

const AddApplication = () => {
  const token = getCookie("token");
  const {currentUser} = useContext(StateContext);
  const userEmail = currentUser? currentUser.email: "";
  const [applicationsLimitExceeded, applicationsLimitExceededSET] = useState(true);
  const [anyApplicationInReview, anyApplicationInReviewSET] = useState(true);
  const [apiData] = useFetch("GET", "applications/applications/?page_size=9999", token);

  useEffect(() => {
    const applications = Array.isArray(apiData?.results)
      ? apiData.results
      : Array.isArray(apiData)
        ? apiData
        : [];

    let anyAppInReview = false;
    applications.forEach(app => {
      if (app.application_status === "In Review") {
        anyAppInReview = true;
      }
    });
    applicationsLimitExceededSET(applications.length >= 3);
    anyApplicationInReviewSET(anyAppInReview);
  }, [apiData]);
  
  return (
    <>
      {
        (applicationsLimitExceeded) &&
        <Alert color="danger">
          You can't submit new application because you have submitted maximum (3) applications already!
        </Alert>
      }

      {
        (!applicationsLimitExceeded && anyApplicationInReview) &&
        <Alert color="danger">
          You can't submit new application because you currently have application In Review.
        </Alert>
      }

      {
        (!anyApplicationInReview && !applicationsLimitExceeded) &&
        <iframe
          aria-label='Sign up for Move Music Services'
          frameborder="0"
          style={{ height: '800px', width: '100%', border: 'none' }}
          src={`https://forms.movemusic.io/movemusic/form/SignupforMoveMusicServices/formperma/I6UoWTKJ7UyOMJQ6l84nWX4REShu_NfxrM6umGN251E?Email=${userEmail}&SystemEmail=${userEmail}`}
          title="Move Music Services Form"
        />
      }
    </>
  );
}

export default AddApplication;